import { useEffect } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";
import React from "react";

/**
 * Renders the form component for Experience module with the specified props.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.form - The form instance.
 * @param {number} props.id - The ID of the form.
 * @param {Function} props.handleSubmit - The function to handle form submission.
 * @param {Function} props.onValuesChange - The function to handle form values change.
 * @param {Object} props.editValues - The values to be edited.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {
  useEffect(() => {
    if (editValues) {
      form.setFieldsValue(editValues);
    }
  }, [editValues, form]);


  /**
   * Process the form data and handle the form submission.
   */
  const onFinish = (data: any) => {
    handleSubmit(data);
  };

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Text
              required
              name="experience"
              label="Experience"
              rules={rules.name()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Zero Experience"
              name="zero_experience"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Level 1 Supporting Activities"
              name="level_1"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Level 2 Executing Activities"
              name="level_2"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Level 3 Managing Activities"
              name="level_3"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Level 4 Planning Strategic Work"
              name="level_4"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Level 5 Leading Strategic Work"
              name="level_5"
              minValue={0}
              maxValue={100}
            />
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
